<template>
  <UnitListItem v-if="!editMode && editItem.Unit" :item="editItem.Unit" @click="openUnit()">
  </UnitListItem>
  <div v-else-if="!editMode" class="px-3" style="opacity: 0.6;" @click="handleFocus(true)">
    No unit set
  </div>

  <v-container v-else class="pt-0">
    <UnitSelect v-model="editItem.UnitId" :externaledit="isNew || editMode"
      :placeholder="$t('servicesystem.common_objects.unit.no_unit')" clearable
      :filter="{ CustomerIdList: [editItem.CustomerId] }" @FocusState="handleFocus">
    </UnitSelect>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UnitSelect from '@/components/Inputs/EntityDropdowns/UnitSelect2.vue';
import UnitListItem from "@/components/ListItems/UnitListItem.vue";

export default {
  name: "MachineUnitEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    UnitSelect,
    UnitListItem,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    openUnit() {
      this.$router.push({ name: 'ViewUnit', params: { unitId: this.editItem.UnitId } })
    }
  },

  computed: {
    isNew() {
      return this.editItem?.Id == null;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>